import { render } from "./pmprb.vue?vue&type=template&id=2c1fcc34"
import script from "./pmprb.vue?vue&type=script&lang=js"
export * from "./pmprb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__